import { useEffect, useRef, type RefObject } from 'react'

export function useRouteMainFocus(
  target: RefObject<HTMLElement | null>,
  routeKey: string,
) {
  const previous = useRef(routeKey)

  useEffect(() => {
    if (previous.current === routeKey) return

    previous.current = routeKey
    target.current?.focus({ preventScroll: true })
  }, [routeKey, target])
}
